import { ApiService } from "@/api";

export default {
  GET_LIST_INTERCOMS({ commit }, payload) {
    return ApiService.intercoms
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_INTERCOMS", data));
  },
  GET_LIST_INTERCOMS_APPEND({ commit }, payload) {
    return ApiService.intercoms
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => {
        commit("SET_LIST_INTERCOMS_APPEND", data);
        return data;
      });
  },
};
